export default __webpack_public_path__ + "media/images/react_icons/boleto-a1e4a50a96439c58a48989f2529f7b85.svg";